webpackJsonp([56],{

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableJobDetail_vue__ = __webpack_require__(726);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99a77864_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableJobDetail_vue__ = __webpack_require__(894);
function injectStyle (ssrContext) {
  __webpack_require__(892)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99a77864"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AvailableJobDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99a77864_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AvailableJobDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["autocomplete"]
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayContainElement */
/* unused harmony export allowedPermission */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return allowToViewCustomerNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return allowToViewAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return allowToAddEditAdminNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowRepricingAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allowRepricingHourly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return companySelectorAirportTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return companySelectorHourly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_constants__ = __webpack_require__(237);


var arrayContainElement = function arrayContainElement(arrayValue) {
  return arrayValue && arrayValue !== null;
};

var allowedPermission = function allowedPermission(currentUserPermission, permissionGroup, permission) {
  return arrayContainElement(currentUserPermission) && currentUserPermission[permissionGroup].includes(permission);
};

var allowToViewCustomerNotes = function allowToViewCustomerNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewCustomerNote");
};

var allowToViewAdminNotes = function allowToViewAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewAdminNote");
};

var allowToAddEditAdminNotes = function allowToAddEditAdminNotes(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "AddEditAdminNote");
};

var allowRepricingAirportTransfer = function allowRepricingAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].AirportTransferReservation, "ViewRepriceHistory");
};

var allowRepricingHourly = function allowRepricingHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "Reprice") && allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].HourlyReservation, "ViewRepriceHistory");
};

var companySelectorAirportTransfer = function companySelectorAirportTransfer(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InquiryAvailability, "CompanySelector");
};

var companySelectorHourly = function companySelectorHourly(currentUserPermission) {
  return allowedPermission(currentUserPermission, __WEBPACK_IMPORTED_MODULE_0__models_constants__["o" /* UserPermissionGroup */].InstantAvailability, "CompanySelector");
};

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapModal_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7861c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapModal_vue__ = __webpack_require__(561);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e7861c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gmap-wrapper"},[(_vm.autocomplete)?_c('div',{staticClass:"pac-card",attrs:{"id":"pac-card"}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pac-container"}},[_c('input',{attrs:{"id":"pac-input","type":"text","placeholder":"Enter a location"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__(500);



var _this = this;



var _baseEndpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/job";

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(filter, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/available" + filter, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function search(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  getSubscribers: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/subscriber/" + reservationId, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function getSubscribers(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(),
  getJobDetails: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/" + reservationId, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function getJobDetails(_x7, _x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }(),
  getListSubscriberProvider: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(reservationId, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].get(_baseEndpoint + "/" + reservationId + "/subscriber/providers", onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function getListSubscriberProvider(_x10, _x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }(),
  dispatchJob: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].post(_baseEndpoint + "/accept", payload, onBeginCallback, onFinallyCallback, onErrorCallback));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function dispatchJob(_x13, _x14, _x15, _x16) {
      return _ref5.apply(this, arguments);
    };
  }(),
  reassignPreferredProvider: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(reservationId, payload, onBeginCallback, onFinallyCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].put(_baseEndpoint + "/" + reservationId + "/preffered-provider/reassign", payload, onBeginCallback, onFinallyCallback));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function reassignPreferredProvider(_x17, _x18, _x19, _x20) {
      return _ref6.apply(this, arguments);
    };
  }(),
  reassignProvider: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(reservationId, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* asyncApi */].put(_baseEndpoint + "/" + reservationId + "/provider/reassign", payload, onBeginCallback, onFinallyCallback, onErrorCallback));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this);
    }));

    return function reassignProvider(_x21, _x22, _x23, _x24, _x25) {
      return _ref7.apply(this, arguments);
    };
  }()
});

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);





var _canvas = void 0;
var _directionsService = void 0;
var _directionsRenderer = void 0;

function _getDirection(origin, destination) {
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    _directionsService.route({
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode.DRIVING
    }, function (result, status) {
      if (status === google.maps.DirectionsStatus.OK) {
        resolve(result);
      } else {
        reject();
      }
    });
  });
}

function _printTimeStamp(item) {
  return item.stringFullDate + " " + item.stringHour + ":" + item.stringMinute;
}

var MaverickDirection = function () {
  function MaverickDirection(config) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MaverickDirection);

    _directionsService = new google.maps.DirectionsService();
    _directionsRenderer = new google.maps.DirectionsRenderer({
      preserveViewport: true
    });
    _canvas = new google.maps.Map(document.getElementById(config.mapId), {
      center: {
        lat: 0,
        lng: 0
      },
      zoom: 9,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });
    _directionsRenderer.setMap(_canvas);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(MaverickDirection, [{
    key: "display",
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(locations) {
        var infoWindow, bounds, path, polyline, index, marker;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                infoWindow = new google.maps.InfoWindow();
                bounds = new google.maps.LatLngBounds();
                path = new google.maps.MVCArray();
                polyline = new google.maps.Polyline({
                  map: _canvas,
                  strokeColor: '#4986E7'
                });


                for (index = 0; index < locations.length; index++) {
                  marker = new google.maps.Marker({
                    position: new google.maps.LatLng(locations[index].point.latitude, locations[index].point.longitude),
                    map: _canvas,
                    // title: _printTimeStamp(locations[index].timeStamp),
                    label: "" + (index + 1)
                  });


                  bounds.extend(marker.position);
                  (function (marker, location) {
                    google.maps.event.addListener(marker, "click", function (_) {
                      infoWindow.setContent(_printTimeStamp(location.timeStamp));
                      infoWindow.open(_canvas, marker);
                    });
                  })(marker, locations[index]);

                  //   if ((index + 1) < locations.length) {
                  //     polyline.setPath(path);
                  //     const directionResult = await _getDirection(
                  //       new google.maps.LatLng(locations[index].point.latitude, locations[index].point.longitude),
                  //       new google.maps.LatLng(locations[index + 1].point.latitude, locations[index + 1].point.longitude));
                  //     for (let pathIndex = 0, len = directionResult.routes[0].overview_path.length; pathIndex < len; pathIndex++) {
                  //       path.push(directionResult.routes[0].overview_path[pathIndex]);
                  //     }
                  //   }
                }

                _canvas.setCenter(bounds.getCenter());
                _canvas.fitBounds(bounds);
                _canvas.setZoom(11);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function display(_x) {
        return _ref.apply(this, arguments);
      }

      return display;
    }()
  }]);

  return MaverickDirection;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickDirection);

/***/ }),

/***/ 726:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_MapModal__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_job_availableJobService__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_google_direction_js__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_userHelper_js__ = __webpack_require__(531);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    mapModal: __WEBPACK_IMPORTED_MODULE_4__components_shared_MapModal__["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: true,
      msg: "Please wait",
      moneyFormat: null,
      reservation: null,
      direction: null,
      allPermissions: [],
      sameBookerAndPassenger: false,
      userType: "Unspecified",
      allServices: null
    };
  },

  computed: {
    isAllowViewAdminNotes: function isAllowViewAdminNotes() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_userHelper_js__["d" /* allowToViewAdminNotes */])(this.allServices);
    },
    isAllowViewCustomerNotes: function isAllowViewCustomerNotes() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__helpers_userHelper_js__["e" /* allowToViewCustomerNotes */])(this.allServices);
    },
    ancillaryTotal: function ancillaryTotal() {
      var total = 0;
      if (this.reservation && this.reservation.ancillaries.length) {
        this.reservation.ancillaries.forEach(function (val) {
          return total += val.qty * val.rate;
        });
      }
      return total;
    },
    progressClassName: function progressClassName() {
      if (this.reservation) {
        switch (this.reservation.progress.toLowerCase()) {
          case "open":
            return "sts_job-open";
          case "run":
            return "sts_job-run";
          case "done":
            return "sts_job-done";
          case "close":
            return "sts_job-closed";
          case "abort":
            return "sts_job-aborted";
          case "rescueoperation":
            return "rescue_operation";
        }
      }
      return "";
    },
    isAutomaticTransmission: function isAutomaticTransmission() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.transmission.toLowerCase() === "at";
    },
    hasPaxCapacity: function hasPaxCapacity() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.paxCapacity && parseInt(this.reservation.vehicle.feature.paxCapacity) > 0;
    },
    hasLargeBaggageCapacity: function hasLargeBaggageCapacity() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.largeBaggageCapacity && parseInt(this.reservation.vehicle.feature.largeBaggageCapacity) > 0;
    },
    hasSmallBaggageCapacity: function hasSmallBaggageCapacity() {
      return this.reservation && this.reservation.vehicle && this.reservation.vehicle.feature && this.reservation.vehicle.feature.smallBaggageCapacity && parseInt(this.reservation.vehicle.feature.smallBaggageCapacity) > 0;
    },
    isAirportTransfer: function isAirportTransfer() {
      return this.reservation && this.reservation.serviceType !== "" && this.reservation.serviceType.toLowerCase() === "airporttransfer";
    },
    isArrivedFlight: function isArrivedFlight() {
      return this.reservation && this.reservation.pickUpLocation && this.reservation.pickUpLocation.isAirport;
    },
    isDepartureFlight: function isDepartureFlight() {
      return this.reservation && this.reservation.dropOffLocation && this.reservation.dropOffLocation.isAirport;
    },
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    cdn: function cdn() {
      return "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com";
    },
    surchargeTotal: function surchargeTotal() {
      return this.reservation.surcharges.length && this.reservation.surcharges.reduce(function (accum, item) {
        return accum + item.rate;
      }, 0);
    },
    postBookingExtrasTotal: function postBookingExtrasTotal() {
      return this.reservation.postBookingExtras.length && this.reservation.postBookingExtras.reduce(function (accum, item) {
        return accum + item.rate;
      }, 0);
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.getUserType();

            case 3:
              _context.next = 5;
              return _this.$store.dispatch("user/getProfile");

            case 5:
              profile = _context.sent;

              _this.allServices = profile.services;
              permissions = profile.services["AvailableJob"];


              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 14;
                break;
              }

              _context.next = 12;
              return _this.getDetails();

            case 12:
              _context.next = 15;
              break;

            case 14:
              _this.$router.push({ path: "/unauthorized" });

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    if (!this.direction) {
      this.direction = new __WEBPACK_IMPORTED_MODULE_6__plugins_google_direction_js__["a" /* default */]({ mapId: "map" });
    }
  },

  methods: {
    startLoader: function startLoader() {
      this.isLoading = true;
    },
    stopLoader: function stopLoader() {
      this.isLoading = false;
    },
    getDetails: function getDetails() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, _reservation, booker, customers, bookerData, passengerData;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__services_job_availableJobService__["a" /* default */].getJobDetails(_this2.$route.params.id, _this2.startLoader, _this2.stopLoader);

              case 2:
                response = _context2.sent;


                if (response.isSuccess) {
                  _this2.reservation = response.data;
                  _this2.moneyFormat = response.data.moneyFormat;

                  _reservation = _this2.reservation, booker = _reservation.booker, customers = _reservation.customers;
                  bookerData = {
                    name: booker.fullName,
                    email: booker.email,
                    phonenumber: "" + booker.phoneCode + booker.phoneNumber
                  };
                  passengerData = {
                    name: customers[0].fullName,
                    email: customers[0].email,
                    phonenumber: "" + customers[0].phoneCode + customers[0].phoneNumber
                  };

                  _this2.sameBookerAndPassenger = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.isEqual(bookerData, passengerData);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getUserType: function getUserType() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var profile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch("user/getProfile");

              case 2:
                profile = _context3.sent;

                _this3.userType = profile.userType;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    openMapModal: function openMapModal() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.reservation.logLocations) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return _this4.direction.display(_this4.reservation.logLocations);

              case 3:
                $(_this4.$refs.mapmodal).modal();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    isButtonShow: function isButtonShow(history) {
      if (history == null || history == undefined) {
        return false;
      }

      var historySplit = history.split(/:(.+)/);
      if (historySplit[0] === "link") {
        return true;
      } else {
        return false;
      }
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    },
    getEventDescription: function getEventDescription(history) {
      return this.$helper.getEventDescription(history, this.userType);
    }
  }
});

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(893);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("6239386c", content, true, {});

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".gmap-point-container[data-v-99a77864]{height:580px!important}.table.table-amount tbody td[data-v-99a77864]:last-child{padding-bottom:10px}", "", {"version":3,"sources":["/app/src/components/job/availableJob/AvailableJobDetail.vue"],"names":[],"mappings":"AACA,uCACE,sBAAyB,CAC1B,AACD,yDACE,mBAAqB,CACtB","file":"AvailableJobDetail.vue","sourcesContent":["\n.gmap-point-container[data-v-99a77864] {\n  height: 580px !important;\n}\n.table.table-amount tbody td[data-v-99a77864]:last-child {\n  padding-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoading && _vm.reservation)?_c('section',{staticClass:"reservation-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"header--reservation-detail"},[_c('div',{staticClass:"header--reservation-box"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb mb-35 pz"},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":'/job/available'}},[_vm._v("\n                      Available Job\n                    ")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                    Details\n                  ")])])]),_vm._v(" "),_c('h4',[_vm._v("Provider Jobs Details")]),_vm._v(" "),_c('div',{class:_vm.progressClassName,style:(_vm.isAirportTransfer && !_vm.isArrivedFlight && !_vm.isDepartureFlight
                    ? 'position: relative; bottom: 5px'
                    : '')}),_vm._v(" "),_c('div',{staticClass:"table-legend"},[_c('ul',[(_vm.isAirportTransfer && _vm.isArrivedFlight)?_c('li',[_c('i',{staticClass:"ic-flight-icon"}),_vm._v("Airport Transfer\n                  ")]):_vm._e(),_vm._v(" "),(_vm.isAirportTransfer && _vm.isDepartureFlight)?_c('li',[_c('i',{staticClass:"ic-flight-departure-icon"}),_vm._v("Airport Transfer\n                  ")]):(
                      _vm.isAirportTransfer &&
                      !_vm.isArrivedFlight &&
                      !_vm.isDepartureFlight
                    )?_c('li',{staticStyle:{"display":"flex"}},[_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]),_vm._v("\n                    Point to Point\n                  ")]):(!_vm.isAirportTransfer)?_c('li',[_c('i',{staticClass:"ic-time"}),_vm._v("Hourly Booking\n                  ")]):_vm._e()])])]),_vm._v(" "),(_vm.userType !== 'ProviderUser')?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Payment Status")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[(_vm.reservation.paymentStatus === 'Complete')?_c('span',{staticClass:"--green35"},[_vm._v("Completed")]):_c('span',{staticClass:"sts-danger"},[_vm._v(_vm._s(_vm.humanize(_vm.reservation.paymentStatus)))])])]):_vm._e(),_vm._v(" "),(_vm.userType !== 'ProviderUser')?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Payment Method")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.humanize(_vm.reservation.paymentMethodDescription)))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Code")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.reservation.code))])])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Reservation Date")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_c('span',[_vm._v(_vm._s(_vm.reservation.reservationDate.stringFullDate))])])])]),_vm._v(" "),_c('div',{staticClass:"mb-25"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"dropandpickup"},[_c('div',{staticClass:"col-sm-12 pz mb-15"},[_c('div',{staticClass:"location-pick-up"},[_vm._v("\n                      "+_vm._s(_vm.reservation.pickUpLocation.name)+"\n                      "),_c('span',{staticClass:"address-location"},[_vm._v(_vm._s(_vm.reservation.pickUpLocation.address))])]),_vm._v(" "),_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-5 prz"},[_c('div',{staticClass:"rent-date"},[_vm._v("\n                          "+_vm._s(_vm.reservation.pickUpDate.day)+"\n                          "+_vm._s(_vm.reservation.pickUpDate.stringShortMonth)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 text-right"},[_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                          "+_vm._s(_vm.reservation.pickUpDate.stringHour)+":"+_vm._s(_vm.reservation.pickUpDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-zone"},[_vm._v("("+_vm._s(_vm.reservation.pickUpDate.offsetName)+")")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 pz pt-10 divider-top-blue"},[_c('div',{staticClass:"location-drop-off text-right"},[_vm._v("\n                      "+_vm._s(_vm.reservation.dropOffLocation.name)+"\n                      "),_c('span',{staticClass:"address-location"},[_vm._v(_vm._s(_vm.reservation.dropOffLocation.address))])]),_vm._v(" "),_c('div',{staticClass:"row mt-10"},[_c('div',{staticClass:"col-sm-5 prz"},[_c('div',{staticClass:"rent-date"},[_vm._v("\n                          "+_vm._s(_vm.reservation.dropOffDate.day)+"\n                          "+_vm._s(_vm.reservation.dropOffDate.stringShortMonth)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 text-right"},[_c('div',{staticClass:"rent-time"},[_c('i',{staticClass:"ic-time"}),_vm._v("\n                          "+_vm._s(_vm.reservation.dropOffDate.stringHour)+":"+_vm._s(_vm.reservation.dropOffDate.stringMinute)+"\n                          "),_c('span',{staticClass:"utc-zone"},[_vm._v("("+_vm._s(_vm.reservation.dropOffDate.offsetName)+")")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 plz text-center"},[_c('div',{staticClass:"map-capture"}),_vm._v(" "),_c('div',{staticClass:"btn btn-flat",on:{"click":function($event){$event.preventDefault();return _vm.openMapModal()}}},[_vm._v("\n                  View Map\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"body--reservation-detail"},[_c('div',{staticClass:"row"},[_c('div',{class:!_vm.sameBookerAndPassenger
                    ? 'col-sm-6 divider-right'
                    : 'col-sm-6'},[_c('i',{staticClass:"ic-businessmen pull-left mr-10 --green"}),_vm._v(" "),_c('h4',{staticClass:"--green"},[_vm._v("Passenger Details")]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.customers[0].title)+".\n                    "+_vm._s(_vm.reservation.customers[0].fullName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.customers[0].phoneCode &&
                      _vm.reservation.customers[0].phoneNumber
                        ? ("(+" + (_vm.reservation.customers[0].phoneCode) + ") " + (_vm.reservation.customers[0].phoneNumber))
                        : "N/A")+"\n                  ")])]),_vm._v(" "),(_vm.userType !== 'ProviderUser')?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.customers[0].email
                        ? _vm.reservation.customers[0].email
                        : "N/A")+"\n                  ")])]):_vm._e(),_vm._v(" "),[(_vm.reservation.numberOfPassengers)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Number of Passengers")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                      "+_vm._s(_vm.reservation.numberOfPassengers)+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.reservation.numberOfSmallLuggages)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Number of Small Luggages")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                      "+_vm._s(_vm.reservation.numberOfSmallLuggages)+"\n                    ")])]):_vm._e(),_vm._v(" "),(_vm.reservation.numberOfBigLuggages)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Number of Big Luggages")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                      "+_vm._s(_vm.reservation.numberOfBigLuggages)+"\n                    ")])]):_vm._e()]],2),_vm._v(" "),(!_vm.sameBookerAndPassenger && _vm.userType !== 'ProviderUser')?_c('div',{class:_vm.sameBookerAndPassenger
                    ? 'col-sm-6 text-right divider-left'
                    : 'col-sm-6 text-right'},[_c('h4',[_vm._v("Booker")]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.booker.title)+".\n                    "+_vm._s(_vm.reservation.booker.fullName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.booker.phoneCode &&
                      _vm.reservation.booker.phoneNumber
                        ? ("(+" + (_vm.reservation.booker.phoneCode) + ") " + (_vm.reservation.booker.phoneNumber))
                        : "N/A")+"\n                  ")])]),_vm._v(" "),(_vm.userType !== 'ProviderUser')?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                    "+_vm._s(_vm.reservation.booker.email
                        ? _vm.reservation.booker.email
                        : "N/A")+"\n                  ")])]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"passenger-flight-info"},[(_vm.reservation.flightInfo)?_c('div',[_c('h4',[_vm._v("Passenger Flight Info")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"--green passenger__flight"},[_vm._v("\n                    "+_vm._s(_vm.reservation.flightInfo.carrierName)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"passenger__flight-number"},[_vm._v("\n                    "+_vm._s(_vm.reservation.flightInfo.carrierCode)+"-"+_vm._s(_vm.reservation.flightInfo.flightNumber)+"\n                  ")])])])]):_vm._e(),_vm._v(" "),(_vm.reservation.noteToDriver)?_c('div',[_c('h4',[_vm._v("Notes to Driver")]),_vm._v(" "),_c('div',{staticClass:"passenger-notes"},[_vm._v("\n                "+_vm._s(_vm.reservation.noteToDriver)+"\n              ")])]):_vm._e(),_vm._v(" "),(
                _vm.isAllowViewCustomerNotes &&
                (_vm.reservation.passengerNameRecord ||
                  _vm.reservation.project ||
                  _vm.reservation.additionalRequest)
              )?_c('div',{staticStyle:{"border-top":"0.5px solid #999"}},[_c('h4',{staticStyle:{"margin-top":"20px"}},[_vm._v("Customer Notes")]),_vm._v(" "),_c('div',{staticClass:"body--reservation-detail additional-table"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.reservation.passengerNameRecord)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("PNR/Client Booking No.")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                        "+_vm._s(_vm.reservation.passengerNameRecord)+"\n                      ")])]):_vm._e(),_vm._v(" "),(_vm.reservation.project)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Project Name")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                        "+_vm._s(_vm.reservation.project)+"\n                      ")])]):_vm._e(),_vm._v(" "),(_vm.reservation.additionalRequest)?_c('div',{staticClass:"label-group"},[_c('div',{staticClass:"label"},[_vm._v("Additional Request")]),_vm._v(" "),_c('div',{staticClass:"label-title"},[_vm._v("\n                        "+_vm._s(_vm.reservation.additionalRequest)+"\n                      ")])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.isAllowViewAdminNotes && _vm.reservation.adminNotes)?_c('div',{staticStyle:{"border-top":"0.5px solid #999"}},[_c('h4',{staticStyle:{"margin-top":"20px"}},[_vm._v("Admin Notes")]),_vm._v(" "),_c('div',{staticClass:"admin-notes"},[_vm._v("\n                "+_vm._s(_vm.reservation.adminNotes)+"\n              ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-addons mt-20"},[_c('div',{staticClass:"panel-group",attrs:{"id":"accordion"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"collapse1"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"trip-info"},_vm._l((_vm.reservation.histories),function(history,index){return _c('div',{key:index},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"time__depart"},[_c('div',{staticClass:"time_Is"},[_vm._v("\n                              "+_vm._s(history.createdDate.stringHour)+":"+_vm._s(history.createdDate.stringMinute)+":"+_vm._s(("" + (history.createdDate.second.toString()
                                    .length > 1
                                    ? ""
                                    : "0") + (history.createdDate.second)))+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"date_Is"},[_vm._v("\n                              ("+_vm._s(history.createdDate.offsetName)+")\n                            ")]),_vm._v(" "),_c('div',{staticClass:"date_Is"},[_vm._v("\n                              "+_vm._s(history.createdDate.stringDate)+"\n                              "+_vm._s(history.createdDate.stringShortMonth)+"\n                              "+_vm._s(history.createdDate.year)+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{class:[
                              index === _vm.reservation.histories.length - 1
                                ? 'end-time-stamp'
                                : 'time-stamp',
                              history.event.toLowerCase().includes('dropped')
                                ? 'dropped'
                                : '' ]},[_c('div',{staticClass:"stamp-status --green"},[_vm._v("\n                              "+_vm._s(_vm.humanize(history.eventText))+"\n                            ")]),_vm._v(" "),(
                                _vm.userType !== 'ProviderUser' ||
                                (_vm.humanize(history.eventText) !== 'Quoted' &&
                                  _vm.humanize(history.eventText) !== 'Paid')
                              )?_c('div',{staticClass:"stamp-desc",domProps:{"innerHTML":_vm._s(_vm.getEventDescription(history))}}):_vm._e(),_vm._v(" "),(_vm.isButtonShow(history.description))?_c('div',[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.getImage(history)}}},[_c('span',[_vm._v("Show")])])]):_vm._e()])])])}),0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"price-detail-header"},[_c('div',{staticClass:"grand-total pbz",style:(_vm.ancillaryTotal <= 0 ? 'border-top: 1px solid #ddd' : '')},[_c('table',{staticClass:"table table-amount",style:(_vm.ancillaryTotal <= 0 ? 'margin-top: 0' : '')},[(
                    _vm.reservation.grandTotal > 0 && _vm.reservation.currencyCode
                  )?_c('thead',[_c('tr',[_c('th',{staticClass:"text-left --green",staticStyle:{"border":"none"}},[_vm._v("\n                      Total Amount\n                    ")]),_vm._v(" "),_c('th',{staticClass:"text-right",staticStyle:{"border":"none"}},[_c('strong',[_vm._v(_vm._s(_vm.reservation.currencyCode)+"\n                        "+_vm._s(_vm.$currencyFormat(
                            _vm.reservation.currencyCode,
                            _vm.reservation.grandTotal
                          )))])])])]):_vm._e(),_vm._v(" "),_c('tbody',[(_vm.reservation.ancillaries.length)?_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("Ancillary")]),_vm._v(" "),(_vm.ancillaryTotal > 0)?_c('td',{staticClass:"text-right"},[_c('strong',[_vm._v(_vm._s(_vm.reservation.currencyCode)+"\n                        "+_vm._s(_vm.$currencyFormat(
                            _vm.reservation.currencyCode,
                            _vm.ancillaryTotal
                          )))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.reservation.ancillaries.length)?_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('ul',{staticClass:"table-list"},_vm._l((_vm.reservation.ancillaries),function(ancillary,index){return _c('li',{key:index},[_vm._v("\n                          "+_vm._s(ancillary.name)),_c('span',[_vm._v("x"+_vm._s(ancillary.qty))]),(_vm.ancillaryTotal > 0)?_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.reservation.currencyCode)+"\n                            "+_vm._s(_vm.$currencyFormat(
                                _vm.reservation.currencyCode,
                                ancillary.rate
                              )))]):_vm._e()])}),0)])]):_vm._e()])])])]),_vm._v(" "),(_vm.reservation.vehicle)?_c('div',{staticClass:"reservation-summary--small"},[(_vm.reservation.vehicle)?_c('div',{staticClass:"brand-box"},[(_vm.reservation.vehicle.className)?_c('div',{staticClass:"type-car"},[_vm._v("\n                "+_vm._s(_vm.reservation.vehicle.className)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cars-brand"},[_vm._v("\n                "+_vm._s(_vm.reservation.vehicle.factoryName)+"\n                "+_vm._s(_vm.reservation.vehicle.brandName)+"\n                "+_vm._s(_vm.reservation.vehicle.plateNumber
                    ? ("(" + (_vm.reservation.vehicle.plateNumber) + ")")
                    : "")+"\n                "),_c('span',{staticClass:"cars-brand-equivalent"},[_vm._v("or equivalent")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.hasPaxCapacity)?_c('div',{staticClass:"capacity-seat"},[_vm._v("\n                    Pax Capacity "+_vm._s(_vm.reservation.vehicle.feature.paxCapacity)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasLargeBaggageCapacity)?_c('div',{staticClass:"capacity-large-baggage"},[_vm._v("\n                    Large Bag. Capacity x"+_vm._s(_vm.reservation.vehicle.feature.largeBaggageCapacity)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.hasSmallBaggageCapacity)?_c('div',{staticClass:"capacity-baggage"},[_vm._v("\n                    Small Bag. Capacity x"+_vm._s(_vm.reservation.vehicle.feature.smallBaggageCapacity)+"\n                  ")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.reservation.vehicle)?_c('div',{staticClass:"cRow"},[_c('div',{staticClass:"col-sm-12"},[_c('img',{staticClass:"cars-image",attrs:{"src":_vm.reservation.vehicle.imageUri
                      ? _vm.reservation.vehicle.imageUri
                      : _vm.cdn + '/images/vehicle-dummy.png',"alt":""}})])]):_vm._e()]):_vm._e()])])])]):_vm._e(),_vm._v(" "),_c('div',{ref:"mapmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('mapModal')],1)])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading text-center"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"--green",attrs:{"data-toggle":"collapse","data-parent":"#accordion","href":"#collapse1"}},[_c('i',{staticClass:"ic-History mr-5"}),_vm._v("Reservation History\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"ic-close"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/56.3cecabfac66fa2840b39.js